/*
Color instructions:

0. Color primary: header and footer
1. Color secondary: tags
2. Color tertiary: Doesn't apply
3. Color background: light palettes must use a light color and dark palettes must use dark color or default #151110
4. Doesn't Apply
*/

const palettes = [
    {
        title: 'Atalanta Light',
        dark: false,
        description: '',
        colors: ['#031752', '#000000', '#012FB6', '#e6e6e6', '#151110'],
    },
    {
        title: 'Atalanta Dark',
        dark: true,
        description: '',
        colors: ['#031752', '#000000', '#012FB6', '#151110', '#f5f3f4'],
    },
    {
        title: 'AFA Light',
        dark: false,
        description: '',
        colors: ['#054264', '#42D0F8', '#2DD1F5', '#CFE4E5', '#151110'],
    },
    {
        title: 'AFA Dark',
        dark: true,
        description: '',
        colors: ['#054264', '#42D0F8', '#2DD1F5', '#151110', '#f5f3f4'],
    },
    {
        title: 'Cool Sunshine Light',
        dark: false,
        description: '',
        colors: ['#e10813', '#525451', '#E7001D', '#f5f3f4', '#151110'],
    },
    {
        title: 'Cool Sunshine Dark',
        dark: true,
        description: '',
        colors: ['#e10813', '#525451', '#E7001D', '#151110', '#f5f3f4'],
    },
    {
        title: 'First Report Light',
        dark: false,
        description: '',
        colors: ['#172b44', '#68d896', '#5AD89C', '#f5f3f4', '#2a5896'],
    },
    {
        title: 'First Report Dark',
        dark: true,
        description: '',
        colors: ['#172b44', '#68d896', '#5AD89C', '#2a5896', '#f5f3f4'],
    },
    {
        title: 'Great Sunshine Light',
        dark: false,
        description: '',
        colors: ['#C7AE45', '#0DA1C4', '#00A2C1', '#F5F3F4', '#151110'],
    },
    {
        title: 'Great Sunshine Dark',
        dark: true,
        description: '',
        colors: ['#C7AE45', '#0DA1C4', '#00A2C1', '#151110', '#F5F3F4'],
    },
    {
        title: 'Green Hope Light',
        dark: false,
        description: '',
        colors: ['#36691D', '#669E02', '#609E2F', '#F5F3F4', '#151110'],
    },
    {
        title: 'Green Hope Dark',
        dark: true,
        description: '',
        colors: ['#36691D', '#669E02', '#609E2F', '#151110', '#F5F3F4'],
    },
    {
        title: 'Lemon Paradise Light',
        dark: false,
        description: '',
        colors: ['#AAD501', '#888888', '#A6D543', '#FFFFFF', '#151110'],
    },
    {
        title: 'Lemon Paradise Dark',
        dark: true,
        description: '',
        colors: ['#AAD501', '#E0E0E0', '#A6D543', '#333333', '#F5F3F4'],
    },
    {
        title: 'Delicious Wine Light',
        dark: false,
        description: '',
        colors: ['#762536', '#0E5190', '#08528C', '#F5F3F4', '#151110'],
    },
    {
        title: 'Delicious Wine Dark',
        dark: true,
        description: '',
        colors: ['#762536', '#0E5190', '#08528C', '#151110', '#F5F3F4'],
    },
    {
        title: 'Clean Pink Light',
        dark: false,
        description: '',
        colors: ['#5B3460', '#8B6491', '#8E648E', '#F5F3F4', '#151110'],
    },
    {
        title: 'Clean Pink Dark',
        dark: true,
        description: '',
        colors: ['#5B3460', '#8B6491', '#8E648E', '#151110', '#F5F3F4'],
    },
    {
        title: 'Blue Mustard Light',
        dark: false,
        description: '',
        colors: ['#2D61A3', '#E47127', '#C46215', '#F5F3F4', '#151110'],
    },
    {
        title: 'Blue Mustard Dark',
        dark: true,
        description: '',
        colors: ['#2D61A3', '#E47127', '#C46215', '#151110', '#F5F3F4'],
    },
    {
        title: 'Blue Purple Light',
        dark: false,
        description: '',
        colors: ['#5EA4BF', '#7B5197', '#7E5293', '#F5F3F4', '#20252B'],
    },
    {
        title: 'Blue Purple Dark',
        dark: true,
        description: '',
        colors: ['#5EA4BF', '#7B5197', '#7E5293', '#20252B', '#F5F3F4'],
    },
    {
        title: 'Aubergine Light',
        dark: false,
        description: '',
        colors: ['#5a0663', '#fdaa14', '#fdaa14', '#ffffff', '#2a2a2a'],
    },
    {
        title: 'Aubergine Dark',
        dark: true,
        description: '',
        colors: ['#5a0663', '#fdaa14', '#fdaa14', '#2a2a2a', '#ffffff'],
    },
    {
        title: 'Deep Green Light',
        dark: false,
        description: '',
        colors: ['#004B4F', '#DA9A17', '#DD9938', '#F5F3F4', '#20252B'],
    },
    {
        title: 'Deep Green Dark',
        dark: true,
        description: '',
        colors: ['#004B4F', '#DA9A17', '#DD9938', '#20252B', '#F5F3F4'],
    },
    {
        title: 'Fresh Mint Light',
        dark: false,
        description: '',
        colors: ['#26BDA2', '#FF5C58', '#FF5A5C', '#F5F3F4', '#151110'],
    },
    {
        title: 'Fresh Mint Dark',
        dark: true,
        description: '',
        colors: ['#26BDA2', '#FF5C58', '#FF5A5C', '#151110', '#F5F3F4'],
    },
    {
        title: 'Pastel Colors Light',
        dark: false,
        description: '',
        colors: ['#70A99A', '#A577A6', '#6CA99B', '#F5F3F4', '#151110'],
    },
    {
        title: 'Pastel Colors Dark',
        dark: true,
        description: '',
        colors: ['#70A99A', '#A577A6', '#6CA99B', '#151110', '#F5F3F4'],
    },
    {
        title: 'Orange Glow Light',
        dark: false,
        description: '',
        colors: ['#ff6600', '#ff7315', '#FF712F', '#ffffff', '#626262'],
    },
    {
        title: 'Orange Glow Dark',
        dark: true,
        description: '',
        colors: ['#ff6600', '#ff7315', '#FF712F', '#626262', '#ffffff'],
    },
    {
        title: 'Rising purple Light',
        dark: false,
        description: '',
        colors: ['#310E5E', '#FEB100', '#00AEE7', '#E6E6E6', '#504C4A'],
    },
    {
        title: 'Rising purple Dark',
        dark: true,
        description: '',
        colors: ['#310E5E', '#FEB100', '#00AEE7', '#504C4A', '#E6E6E6'],
    },
    {
        title: 'Bright thoughts Light',
        dark: false,
        description: '',
        colors: ['#181818', '#D0BE00', '#8F1062', '#FCF8F5', '#181818'],
    },
    {
        title: 'Bright thoughts Dark',
        dark: true,
        description: '',
        colors: ['#181818', '#D0BE00', '#8F1062', '#181818', '#FCF8F5'],
    },
    {
        title: 'Red Bull Light',
        dark: false,
        description: '',
        colors: ['#181818', '#FB5245', '#FF504B', '#FCF8F5', '#181818'],
    },
    {
        title: 'Red Bull Dark',
        dark: true,
        description: '',
        colors: ['#181818', '#FB5245', '#FF504B', '#181818', '#FCF8F5'],
    },
    {
        title: 'Red Bull Magenta Light',
        dark: false,
        description: '',
        colors: ['#181818', '#ee009b', '#F50097', '#FCF8F5', '#181818'],
    },
    {
        title: 'Red Bull Magenta Dark',
        dark: true,
        description: '',
        colors: ['#181818', '#ee009b', '#F50097', '#181818', '#FCF8F5'],
    },
    {
        title: 'Purple Blast Light',
        dark: false,
        description: '',
        colors: ['#462683', '#987ECC', '#9B7FC7', '#FCF8F5', '#181818'],
    },
    {
        title: 'Purple Blast Dark',
        dark: true,
        description: '',
        colors: ['#462683', '#987ECC', '#9B7FC7', '#231342', '#231342'],
    },
    {
        title: 'Watermelon Crush Light',
        dark: false,
        description: '',
        colors: ['#FA4F55', '#33FFCC', '#FF4D58', '#FCF8F5', '#181818'],
    },
    {
        title: 'Watermelon Crush Dark',
        dark: true,
        description: '',
        colors: ['#FA4F55', '#33FFCC', '#FF4D58', '#181818', '#FCF8F5'],
    }
];

export default palettes;
